<template>
  <div class="bgBox" :style="{ height: height }">
    <div class="closeBox">
      选择联系人<img
        class="close"
        @click="$emit('close')"
        src="../../assets/close.png"
      />
    </div>
    <div
      class="customerWrapper"
      style="position: absolute;top: 44px;bottom: 0;width: 100%;overflow:scroll"
    >
      <div class="customerBox" v-for="(res, index) in contactList" :key="index">
        <div class="name">
          {{ res.userName }}
        </div>
        <div class="phone">
          <img src="../../assets/iconPhone.png" />{{ res.phone }}
        </div>
        <div class="choose" @click="choose(res)">选择</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getContactList } from "../../api/identify";

export default {
  name: "contactList",
  data() {
    return {
      contactList: []
    };
  },
  props: ["companyId"],
  computed: {
    height() {
      return document.body.clientHeight - 40 + "px";
    }
  },
  created() {
    this.contactList = [];
    this.getContactList();
  },
  mounted() {},
  methods: {
    getContactList() {
      getContactList({ companyId: this.companyId })
        .then(res => {
          this.contactList = res;
        })
        .catch(err => {
          this.$showError(err);
        });
    },

    choose(res) {
      this.$emit("change", {
        clientId: res.userId,
        name: res.userName,
        phone: res.phone
      });
    },

    close() {
      this.$emit("close", false);
    }
  }
};
</script>

<style scoped>
.search {
  width: 120px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  font-size: 14px;
}
.unIdentity {
  color: #eb8f8f;
  background: #feeeee;
  border: 1px solid #eb8f8f;
}
.idcard-identity {
  font-size: 10px;
  border-radius: 30px;
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  display: inline-block;
}
.closeBox {
  position: relative;
  width: 100%;
  height: 88px;
  background: #0376ec;
  line-height: 88px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}

.close {
  position: absolute;
  display: block;
  top: 20px;
  right: 20px;
  width: 48px;
  height: 48px;
}
.bgBox {
  background-color: #fff;
  width: 100%;
  margin-top: 92px;
}

.loadMore {
  margin: 36px 0;
  text-align: center;
  font-size: 14px;
}

.loadMore img {
  width: 32px;
  height: 32px;
  vertical-align: middle;
  margin-right: 20px;
}

.searchBox {
  overflow: hidden;
  height: 64px;
  margin: 20px;
  padding: 0 10px;
  display: flex;
}
.searchWrapper {
  background: #fff;
  overflow: hidden;
  border-bottom: 1px solid #e6e6e6;
}

.searchIcon {
  width: 32px;
  height: 32px;
  display: inline-block;
  margin: 16px 32px;
}

.inputBox {
  padding: 14px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #eee;
  flex: 1;
}

.searchInput {
  font-size: 14px;
  border: none;
}

.customerWrapper {
  width: 100%;
  background: #fff;
}

.customerBox {
  padding: 30px 0;
  margin: 0 30px;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  position: relative;
}

.name {
  font-size: 14px;
  color: #262626;
  height: 40px;
  line-height: 40px;
}

.phone {
  font-size: 14px;
  color: #777777;
  height: 40px;
  line-height: 40px;
}

.phone img {
  width: 32px;
  height: 32px;
  margin: 4px 0;
  display: inline-block;
  vertical-align: bottom;
}

.choose {
  position: absolute;
  top: 50px;
  right: 0;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  font-size: 12px;
  line-height: 40px;
  color: #fff;
  background: linear-gradient(59deg, #fab737, #ff8610);
}
.iconsousuo {
  font-size: 12px;
  line-height: 64px;
  margin-right: 10px;
}
</style>
